<template>
  <div id="app" :style="{height: `${height}px`}">
    <component :is="currentComponent" @complete="progress" />
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import Desktop from '@/components/Desktop'

const STEPS = [
    Loading,
    Desktop
]

export default {
  computed: {
    currentComponent () {
      return STEPS[this.step]
    }
  },
  data () {
    return {
      step: 0,
      height: 0,
      setHeight: () => {
        this.height = window.innerHeight
      }
    }
  },
  methods: {
    ready () {
      this.setHeight()
      window.addEventListener('resize', this.setHeight)
    },
    destroy () {
      window.removeEventListener('resize', this.setHeight)
    },
    progress() {
      this.step += 1
    }
  },
  mounted () {
    this.ready()
  },
  beforeDestroy () {
    this.destroy()
  }
}
</script>

<style lang="scss">
@import "assets/scss/reboot";
@import "assets/scss/ui";

#app {
  width: 100vw;
  height: 100vh;
}
</style>
